<template>
  <v-footer class="fifth" dark>
      <v-container class="pt-0 pb-0">
        <v-row class="">
          <v-col cols="3" class="d-flex align-center">
            <span class="title font-weight-regular pl-4">2021</span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4" class="d-flex justify-end align-center">
            <span class="font-weight-regular title pr-4">Built with <span class=" font-weight-bold">Vue.js</span></span>
            <!-- <v-img
            src=""
            >
            </v-img> -->
          </v-col>
        </v-row>
      </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>